export const ORDER = {
  MUTATIONS: {
    SET_CURRENT_STEP: 'order-mutation-current-step',
    NEXT_STEP: 'order-mutation-next-step',
    SET_ZIP_CODE: 'order-mutation-zip-code',
    SET_MOVING_META: 'order-mutation-set-moving-meta',
    SET_ORDER_PROPS: 'order-mutation-set-props',
    SET_ORDER_POPUP: 'order-mutation-set-order-popup'
  },
  ACTIONS: {
    PREVIOUS_STEP: 'order-action-previous-step',
    NEXT_STEP: 'order-action-next-step',
  },
  GETTERS: {
    LIST: 'order-getters-list',
    CURRENT_STEP: 'order-getters-current-step',
    ZIP_CODE: 'order-getters-zip-code',
    PARTNER_LOGO: 'order-getters-partner-logo',
    MOVING_META: 'order-getters-moving-meta',
    ORDER_PROPS: 'order-mutation-get-props',
    ORDER_POPUP: 'order-mutation-order-popup'
  }
}
